import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { lastValueFrom } from 'rxjs';

import { CustomerModuleKey } from '../models/customer';
import { AuthService } from '../shared-components/ng-login/auth/auth.service';
import { CustomerService } from './customer.service';

export const cognitoGuard: CanActivateFn = async () => {
  const customerService = inject(CustomerService);
  const authService = inject(AuthService);

  const modules = await lastValueFrom(customerService.getCustomerModules(true));
  const isCognitoEnabled = customerService.isCustomerModuleEnabled(CustomerModuleKey.COGNITO_LOGIN);
  if (isCognitoEnabled && !authService.loggedIn()) {
    const config = modules?.modules?.COGNITO_LOGIN?.config;
    const domain = config?.domain;
    const clientId = config?.client_id;
    const redirectUrl = config?.redirect_url;
    if (!domain || !clientId || !redirectUrl) {
      return false;
    }

    const urlMatch: { [key: string]: RegExp } = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      forgotPassword: /\/reset-password/,
      signup: /\/signup/
    };
    const matchedUrl = Object.keys(urlMatch).find((key) => urlMatch[key].test(window.location.pathname));
    if (!matchedUrl) {
      return false;
    }
    const baseUrl = `${domain}/${matchedUrl}`;

    const url = new URL(baseUrl);

    /* eslint-disable @typescript-eslint/naming-convention */
    url.search = new URLSearchParams({
      response_type: 'code',
      scope: 'email openid profile',
      client_id: clientId,
      redirect_uri: redirectUrl,
      lang: 'es'
    }).toString();

    window.location.href = url.toString();

    return false;
  }

  return true;
};
